var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.357 8.786a.643.643 0 1 0 1.286 0 .643.643 0 0 0-1.286 0m.215-4.072V7.18c0 .058.048.107.107.107h.643a.107.107 0 0 0 .107-.107V4.714a.107.107 0 0 0-.107-.107h-.643a.107.107 0 0 0-.107.107m6.37 5.893L6.373.964A.42.42 0 0 0 6 .75a.42.42 0 0 0-.37.214L.057 10.607a.43.43 0 0 0 .37.643h11.144c.33 0 .536-.356.37-.643M1.45 10.234 6 2.355l4.551 7.877z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgWarning;